export const isArray = Array.isArray || (<T>(x: any): x is T[] => x && typeof x.length === 'number');



// WEBPACK FOOTER //
// ../../src/util/isArray.ts